import { getMerchantWithSteps as AT, applyStepConfig as stepsAT } from './at.fixture';
import { getMerchantWithSteps as AU, applyStepConfig as stepsAU } from './au.fixture';
import { getMerchantWithSteps as BE, applyStepConfig as stepsBE } from './be.fixture';
import { getMerchantWithSteps as CA, applyStepConfig as stepsCA } from './ca.fixture';
import { getMerchantWithSteps as DE, applyStepConfig as stepsDE } from './de.fixture';
import { getMerchantWithSteps as FI, applyStepConfig as stepsFI } from './fi.fixture';
import { getMerchantWithSteps as FR, applyStepConfig as stepsFR } from './fr.fixture';
import { getMerchantWithSteps as GB, applyStepConfig as stepsGB } from './gb.fixture';
import { getMerchantWithSteps as NL, applyStepConfig as stepsNL } from './nl.fixture';
import { getMerchantWithSteps as KI, applyStepConfig as stepsKI } from './ki.fixture';
import { getMerchantWithSteps as NO, applyStepConfig as stepsNO } from './no.fixture';
import { getMerchantWithSteps as SE, applyStepConfig as stepsSE } from './se.fixture';
import { getMerchantWithSteps as US, applyStepConfig as stepsUS } from './us.fixture';
import { getMerchantWithSteps as IT, applyStepConfig as stepsIT } from './it.fixture';
import { getMerchantWithSteps as PL, applyStepConfig as stepsPL } from './pl.fixture';
import { getMerchantWithSteps as PT, applyStepConfig as stepsPT } from './pt.fixture';
import { getMerchantWithSteps as OTHER, applyStepConfig as stepsOther } from './other.fixture';

const allMerchantsMap = { AT, AU, BE, CA, DE, FI, FR, GB, NL, KI, NO, SE, US, IT, PL, PT, OTHER };

export const stepMap = {
  AT: Object.keys(stepsAT),
  AU: Object.keys(stepsAU),
  BE: Object.keys(stepsBE),
  CA: Object.keys(stepsCA),
  DE: Object.keys(stepsDE),
  FI: Object.keys(stepsFI),
  FR: Object.keys(stepsFR),
  GB: Object.keys(stepsGB),
  NL: Object.keys(stepsNL),
  KI: Object.keys(stepsKI),
  NO: Object.keys(stepsNO),
  SE: Object.keys(stepsSE),
  US: Object.keys(stepsUS),
  IT: Object.keys(stepsIT),
  PL: Object.keys(stepsPL),
  PT: Object.keys(stepsPT),
  OTHER: Object.keys(stepsOther),
};

export const getMerchantForCountry = (country = 'OTHER') =>
  allMerchantsMap[country] || allMerchantsMap.OTHER;

export const getMerchantWithSteps = (country = 'OTHER', applySteps = []) =>
  (allMerchantsMap[country] || allMerchantsMap.OTHER)(applySteps);
